import(/* webpackMode: "eager" */ "/app/app/components/common/FAQ.js");
import(/* webpackMode: "eager" */ "/app/app/styles/components/pages/faq/faq-page-banner.module.scss")